"use client";

import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import Section from "../Section";

const CookiePolicy = () => {
  const t = useTranslations("cookiePolicy.sections");

  return (
    <div className="gs--page-column flex flex-col gap-5 py-16">
      <Section title={t("intro.title")}>
        <p>{t("intro.text")}</p>
      </Section>

      <Section title={t("necessary.title")}>
        <p>{t("necessary.text")}</p>
      </Section>

      <Section title={t("analytics.title")}>
        <p>{t("analytics.text")}</p>
      </Section>

      <Section title={t("moreInfo.title")}>
        <p>
          {t.rich("moreInfo.text", {
            link: (chunks) => (
              <Link href="/datenschutz" className="text-primary underline">
                {chunks}
              </Link>
            ),
          })}
        </p>
      </Section>
    </div>
  );
};

export default CookiePolicy;
